import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import PublicTopNav from '../components/PublicTopNav';
import SiteFooter from '../components/SiteFooter';
import { COMPANY } from '../legal/company';
import { LegalDocument, getLegalDocument } from '../legal/documents';
import usePageMeta from '../hooks/usePageMeta';

const LegalPage: React.FC<{ doc: LegalDocument['id'] }> = ({ doc: docId }) => {
  const policy = getLegalDocument(docId);

  usePageMeta({
    title: policy.metaTitle,
    description: policy.metaDescription,
    path: policy.path,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [policy.path]);

  if (!policy) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="nova-page">
      <PublicTopNav activePath={policy.path} />

      <main className="pt-[68px]">
        <article className="max-w-3xl mx-auto px-6 lg:px-12 py-16 sm:py-20">
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-nova-text mb-3">{policy.title}</h1>
          <p className="text-sm text-nova-text3 mb-8">Last updated: {COMPANY.effectiveDate}</p>
          <p className="text-nova-text2 leading-relaxed mb-10">{policy.intro}</p>

          <div className="space-y-10">
            {policy.sections.map((section) => (
              <section key={section.heading}>
                <h2 className="font-display text-xl font-bold text-nova-text mb-3">{section.heading}</h2>
                {section.paragraphs?.map((p) => (
                  <p key={p.slice(0, 48)} className="text-nova-text2 leading-relaxed mb-3">
                    {p}
                  </p>
                ))}
                {section.bullets && (
                  <ul className="list-disc pl-5 space-y-2 text-nova-text2 leading-relaxed">
                    {section.bullets.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}
              </section>
            ))}
          </div>
        </article>
      </main>

      <SiteFooter />
    </div>
  );
};

export default LegalPage;
